import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDebounceValue } from 'usehooks-ts';
import * as S from './ShopsSearch.styles';
import { SearchIcon } from '@/components/UI/Icons/Icons';

const SEARCH_DEBOUNCE_MS = 400;

export interface ShopsSearchProps {
  defaultSearch?: string;
  onSearchChange?: (value: string) => void;
}

export const ShopsSearch: React.FC<ShopsSearchProps> = ({
  defaultSearch = '',
  onSearchChange,
}) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState(defaultSearch);
  const [debouncedSearch] = useDebounceValue(search, SEARCH_DEBOUNCE_MS);

  useEffect(() => {
    onSearchChange?.(debouncedSearch.trim());
  }, [debouncedSearch]);

  return (
    <S.SearchWrapper>
      <S.SearchField>
        <S.SearchIconWrap>
          <SearchIcon width={18} height={18} />
        </S.SearchIconWrap>
        <S.SearchInput
          value={search}
          placeholder={t('pages.shops.search_placeholder')}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setSearch(e.target.value)
          }
        />
      </S.SearchField>
    </S.SearchWrapper>
  );
};
